import Skeleton from 'react-loading-skeleton'

export const DigitalProductStoreWithdrawBottomSheetRewardRequestsSkeleton =
  () => {
    return (
      <div className="flex flex-col gap-4">
        <Skeleton height={64} className="rounded overflow-hidden" />
        <Skeleton height={64} className="rounded overflow-hidden" />
        <Skeleton height={64} className="rounded overflow-hidden" />
        <Skeleton height={64} className="rounded overflow-hidden" />
      </div>
    )
  }
